// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__T7e-Q","unreadBadge":"styles_unreadBadge__2OtJC","modalContent":"styles_modalContent__3S-iE","modal":"styles_modal__15-vJ"};